import { exhaustiveGuard } from "@pathwright/ux/src/utils/typing"
import {
  GroupStatus,
  InvitationFragment,
  InvitationType
} from "@pathwright/graphql-client/src/generated"
import {
  CohortInvitationRoleInt,
  INVITATION_TYPE_PERMISSION_MAP,
  MentorGroupInvitationRoleInt,
  ROLES,
  ROLE_CONFIGS,
  ROLE_DESCRIPTORS,
  ROLE_ICONS,
  ROLE_LABELS,
  ROLE_LABELS_PLURAL,
  ROLE_TYPE_OFFERING,
  SchoolInvitationRoleInt
} from "./constants"

export const getRoleOptions = (type: any, filter: any, { t, tca }: any) => {
  const withLabelAndDescriptor = (role: any) => {
    return {
      value: role,
      icon: ROLE_ICONS[type]?.[role],
      label: tca(ROLE_LABELS[type][role]),
      label_plural: tca(ROLE_LABELS_PLURAL[type][role]),
      descriptor: t(ROLE_DESCRIPTORS[type][role]),
      roleType: role
    }
  }

  let roles = ROLES[type]

  if (filter) {
    roles = roles.filter((role: any) => filter(type, role))
  }

  return roles.map(withLabelAndDescriptor)
}

export const filterAvailableRoles = (type: any, role: any, group: any) => {
  switch (type) {
    case ROLE_TYPE_OFFERING:
      return group
        ? !!(
            group.status !== GroupStatus.Completed &&
            group.permissions &&
            group.permissions[INVITATION_TYPE_PERMISSION_MAP[type][role]]
          )
        : true // if no group, simple allow all role options
    default:
      return true
  }
}

export function getInvitationRoleConfig(invitation: InvitationFragment) {
  switch (invitation.invitation_type) {
    case InvitationType.Cohort:
      return ROLE_CONFIGS[invitation.invitation_type].roles[
        invitation.invitation_role as CohortInvitationRoleInt
      ]
    case InvitationType.School:
      return ROLE_CONFIGS[invitation.invitation_type].roles[
        invitation.invitation_role as SchoolInvitationRoleInt
      ]
    case InvitationType.CommunityGroup:
      return ROLE_CONFIGS[invitation.invitation_type].roles[
        invitation.invitation_role as MentorGroupInvitationRoleInt
      ]
    default:
      return exhaustiveGuard(invitation.invitation_type)
  }
}
